export const getNumberOfPages = (rowCount, rowsPerPage) => rowsPerPage === -1 ? 1 : Math.ceil(rowCount / rowsPerPage);

export const recalculatePage = (prevPage, nextPage) => Math.min(prevPage, nextPage);

export const detectRTL = (direction = 'auto') => {
  if (direction === 'auto') {
    const canUse = !!(
      typeof window !== 'undefined' &&
      window.document &&
      window.document.createElement
    );

    return (
      canUse &&
      (document.getElementsByTagName('BODY')[0] === 'rtl' ||
        document.getElementsByTagName('HTML')[0].dir === 'rtl')
    );
  }

  return direction === 'rtl';
};
